<template>
  <div class="step-form step-form--centered">
    <h2 class="step-form__title">{{ $t('step4.title') }}</h2>
    <p class="step-form__subtitle">{{ $t('step4.subtitle') }}</p>

    <div class="choice-grid">
      <button
        v-for="opt in options"
        :key="opt.value"
        class="choice-card"
        :class="{ 'choice-card--selected': formData.channelManager === opt.value }"
        @click="select(opt.value)"
      >
        <span class="choice-card__label">{{ opt.label }}</span>
        <div class="choice-card__check">
          <svg v-if="formData.channelManager === opt.value" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChannelManager',
  props: { formData: Object },
  computed: {
    options() {
      const keys = ['hostaway', 'siteminder', 'apaleo', 'cloudbeds', 'rentalsunited', 'other', 'none']
      return keys.map(k => ({ value: k, label: this.$t('step4.options.' + k) }))
    },
  },
  methods: {
    select(value) {
      this.$emit('update', { channelManager: value })
    },
  },
}
</script>

<style lang="scss" scoped>
.step-form {
  &--centered { text-align: center; }

  &__title {
    font-size: clamp(1.4rem, 3vw, 2rem);
    font-weight: 800;
    margin-bottom: 0.4rem;
    background: linear-gradient(135deg, #fff 30%, var(--gold-light));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__subtitle {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 2rem;
  }
}

.choice-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  max-width: 500px;
  margin: 0 auto;

  @media (max-width: 500px) { grid-template-columns: 1fr 1fr; }
}

.choice-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;

  &:hover {
    border-color: rgba(208, 176, 146, 0.25);
    background: rgba(208, 176, 146, 0.04);
  }

  &--selected {
    border-color: var(--gold);
    background: rgba(208, 176, 146, 0.08);
    color: var(--gold-light);
    box-shadow: 0 0 0 2px rgba(208, 176, 146, 0.12);
  }

  &__label { flex: 1; }

  &__check {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1.5px solid rgba(255, 255, 255, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s;
  }

  &--selected &__check {
    border-color: var(--gold);
    background: var(--gold);
    color: var(--navy);
  }
}
</style>
